import { NgModule } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { eventsFeatureKey, eventsReducer } from './+state/events/events.reducer';
import { EventsEffects } from './+state/events/events.effects';

@NgModule({
    providers: [provideState(eventsFeatureKey, eventsReducer), provideEffects([EventsEffects])]
})
export class EventModule {}
